import { startAppListening, persistor } from '../..';
import { STORAGE } from '../../../constants';
import { isAuthenticated } from '../../../routing/isAuthenticated';
import { removeToken, setToken } from '../../../services/network/api';
import { setItemToLocalStorage } from '../../../services/network/storage';
import TokenService from '../../../services/network/tokenService';
import { clearAllPendingImages } from '../../../services/advert/pendingImages';
import {
    clearAdvertReturn,
    clearAllAdvertDrafts,
} from '../../../services/advert/advertDraft';
import {
    forgotPassword,
    getAccountById,
    login,
    logout,
    newPassword,
    newPhone,
    signUp,
} from '../../reducers/account/accountThunks';
import { setIsAuthenticated } from '../../reducers/account/auth';
import { toggleForgotPasswordModal } from '../../reducers/common/modals/forgotModal';
import { toggleNewPhoneModal } from '../../reducers/common/modals/newPhoneModal';
import { toggleNewPasswordModal } from '../../reducers/common/modals/newPasswordModal';
import {
    clearAccountData,
    setAccountDataLoading,
} from '../../reducers/account/account';
import toast from 'react-hot-toast';
import i18n from '../../../services/i18n';
import { isAnyOf } from '@reduxjs/toolkit';
import {
    buyAdverts,
    buyPremium,
    buyTop,
} from '../../reducers/common/thunks/topThunks';
import { toggleBuyTopModal } from '../../reducers/common/modals/buyTopModal';
import { toggleBuyAdvertsModal } from '../../reducers/common/modals/buyAdvertsModal';
import { toggleBuyPremiumModal } from '../../reducers/common/modals/buyPremiumModal';
import { migrateGuestFavorites } from '../../reducers/common/favorite/favoriteThunks';
import { completeGoogleSignup } from '../../reducers/account/accountThunks';

startAppListening({
    actionCreator: login.fulfilled,
    effect: (action, store) => {
        const { accessToken, refreshToken, accountId } = action.payload;
        TokenService.storeAccessToken(accessToken);
        TokenService.storeRefreshToken(refreshToken);
        setItemToLocalStorage(STORAGE.ACCOUNT_ID, accountId);

        setToken(accessToken);

        store.dispatch(setIsAuthenticated(isAuthenticated(accessToken)));
        store.dispatch(getAccountById(accountId));
        store.dispatch(migrateGuestFavorites());
    },
});

startAppListening({
    actionCreator: completeGoogleSignup.fulfilled,
    effect: (_action, store) => {
        store.dispatch(migrateGuestFavorites());
    },
});

startAppListening({
    matcher: isAnyOf(login.pending, getAccountById.pending),
    effect: (_action, store) => {
        store.dispatch(setAccountDataLoading(true));
    },
});

const extractErrorCode = (action) => {
    const p = action?.payload;
    if (typeof p === 'string' && p) return p;
    if (p && typeof p === 'object') {
        if (typeof p.message === 'string' && p.message) return p.message;
        if (typeof p.error === 'string' && p.error) return p.error;
    }
    const em = action?.error?.message;
    if (typeof em === 'string' && em && em !== 'Rejected') return em;
    return 'errorOccurred';
};

startAppListening({
    actionCreator: login.rejected,
    effect: (action, store) => {
        store.dispatch(setAccountDataLoading(false));
        const code = extractErrorCode(action);
        toast.error(i18n.t(code) || i18n.t('errorOccurred'), {
            id: 'login-error',
        });
    },
});

startAppListening({
    actionCreator: signUp.rejected,
    effect: (action) => {
        const code = extractErrorCode(action);
        toast.error(i18n.t(code) || i18n.t('errorOccurred'));
    },
});

startAppListening({
    actionCreator: buyTop.fulfilled,
    effect: (_action, store) => {
        store.dispatch(toggleBuyTopModal());
    },
});

startAppListening({
    actionCreator: buyAdverts.fulfilled,
    effect: (_action, store) => {
        store.dispatch(toggleBuyAdvertsModal());
    },
});

startAppListening({
    actionCreator: buyPremium.fulfilled,
    effect: (_action, store) => {
        store.dispatch(toggleBuyPremiumModal());
    },
});

startAppListening({
    matcher: isAnyOf(logout.fulfilled, logout.rejected),
    effect: async (_action, store) => {
        localStorage.removeItem(TokenService.ACCESS_TOKEN);
        localStorage.removeItem(TokenService.REFRESH_TOKEN);
        localStorage.removeItem(STORAGE.ACCOUNT_ID);
        removeToken();

        store.dispatch(clearAccountData());
        store.dispatch(setIsAuthenticated(false));

        localStorage.removeItem('persist:account');
        localStorage.removeItem('persist:auth');
        await persistor.purge();

        clearAllPendingImages();
        clearAdvertReturn();
        clearAllAdvertDrafts();
    },
});

startAppListening({
    actionCreator: getAccountById.fulfilled,
    effect: (action, store) => {
        store.dispatch(setAccountDataLoading(false));
        const data = action.payload;
        const account = data.account;
        return account ?? {};
    },
});

startAppListening({
    actionCreator: forgotPassword.fulfilled,
    effect: (_action, store) => {
        store.dispatch(toggleForgotPasswordModal());
    },
});

startAppListening({
    actionCreator: forgotPassword.rejected,
    effect: (action) => {
        const code = extractErrorCode(action);
        toast.error(i18n.t(code) || i18n.t('errorOccurred'));
    },
});

startAppListening({
    actionCreator: newPassword.fulfilled,
    effect: (_action, store) => {
        store.dispatch(toggleNewPasswordModal());
    },
});

startAppListening({
    actionCreator: newPassword.rejected,
    effect: (action) => {
        const code = extractErrorCode(action);
        toast.error(i18n.t(code) || i18n.t('errorOccurred'));
    },
});

startAppListening({
    actionCreator: newPhone.fulfilled,
    effect: (_action, store) => {
        store.dispatch(toggleNewPhoneModal());
    },
});

startAppListening({
    actionCreator: newPhone.rejected,
    effect: (action) => {
        const code = extractErrorCode(action);
        toast.error(i18n.t(code) || i18n.t('errorOccurred'));
    },
});
